import { createMembershipApiClient } from '@b2ag/module-universcoop-sdk'
import { getConfig } from '@b2ag/micro-front-tools'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { useAuthService } from '@b2ag/auth'

export function provideMembershipApiClient() {
  const userApiHost = getConfig('USER_API_HOST')
  const logger = useLogger()
  const callerId = buildCallerId()

  return createMembershipApiClient(userApiHost, {
    callerId,
    accessTokenSource: () => useAuthService().getAccessToken(),
    logger,
  })
}
